export enum CompanyType {
    Unknown,
    LiveAdmins1,
    LiveAdmins2,
    EaglyHills,
    DEP,
    DEPClient
}